export const projectConfig = {
  apiUrl: process.env.REACT_APP_API_URL,
}
